import { Link } from 'react-router';
import { Icon } from '../components/Icon';
import { Seo } from '../components/Seo';
import { siteConfig } from '../config/site';

export function AboutPage() {
  return (
    <>
      <Seo title="About" description="Wavecraft Audio is an independent audio software studio focused on musical decisions, honest evaluation and durable tools." path="/about" />
      <section className="page-hero about-hero section--grain">
        <div className="shell page-hero__grid">
          <div>
            <span className="eyebrow eyebrow--line">Independent by design</span>
            <h1>Small catalog. Deep iteration. Direct responsibility for the result.</h1>
          </div>
          <div className="page-hero__aside">
            <p>Wavecraft Audio is a focused software studio built around one idea: a plugin should make an audible relationship easier to understand, not simply add another layer of controls.</p>
          </div>
        </div>
      </section>

      <section className="section manifesto-section">
        <div className="shell manifesto-section__grid">
          <div className="manifesto-section__index">01 / Position</div>
          <div>
            <p className="manifesto-lead">We build for the moment when a mix is close, but the reason it still feels wrong is difficult to isolate.</p>
            <p>That work often lives between familiar categories: density versus blur, size versus congestion, clarity versus fatigue, width versus a weak center. Our processors are organized around those listening problems rather than around a long inventory of technical stages.</p>
          </div>
        </div>
      </section>

      <section className="section values-section">
        <div className="shell">
          <div className="section-heading section-heading--split">
            <div><span className="eyebrow">Working principles</span><h2>What the product should make easier.</h2></div>
            <p>This copy is designed as credible positioning rather than a fictional founder story. Add your own history, photograph and biography when the brand is finalized.</p>
          </div>
          <div className="values-grid">
            <article><span>01</span><h3>Hear the consequence</h3><p>A control should communicate a meaningful sonic relationship, not conceal a pile of unrelated parameters.</p></article>
            <article><span>02</span><h3>Compare honestly</h3><p>Gain management, predictable bypass and useful metering help prevent louder from winning automatically.</p></article>
            <article><span>03</span><h3>Respect the session</h3><p>Fast loading, stable recall, automation safety and quiet failure modes matter as much as the headline sound.</p></article>
            <article><span>04</span><h3>Support the owner</h3><p>Customers need recoverable accounts, clear installers, offline options and a direct route to a person when automation stops helping.</p></article>
          </div>
        </div>
      </section>

      <section className="section studio-model-section">
        <div className="shell studio-model-section__grid">
          <div className="studio-model-section__visual">
            <div className="studio-grid-art" aria-hidden="true">
              {Array.from({ length: 48 }, (_, index) => <i key={index} />)}
              <span>WAVE / CRAFT</span>
            </div>
          </div>
          <div>
            <span className="eyebrow">The studio model</span>
            <h2>Build fewer things. Keep listening longer.</h2>
            <p>A focused catalog makes it possible to keep the product language, support experience, installers and licensing consistent. It also leaves room for the less visible work that determines whether a plugin remains dependable after the launch cycle ends.</p>
            <dl className="studio-model__facts">
              <div><dt>Catalog</dt><dd>Focused processors</dd></div>
              <div><dt>Delivery</dt><dd>Direct customer accounts</dd></div>
              <div><dt>Priority</dt><dd>Sound, stability, recovery</dd></div>
            </dl>
          </div>
        </div>
      </section>

      <section className="section about-cta">
        <div className="shell about-cta__inner">
          <div><span className="eyebrow">Hear the tools</span><h2>{siteConfig.brand.tagline}</h2></div>
          <Link className="button button--dark button--large" to="/plugins">Explore the collection <Icon name="arrow" /></Link>
        </div>
      </section>
    </>
  );
}
